import { render, staticRenderFns } from "./catSocialNetwork.vue?vue&type=template&id=7cd5a2d2&scoped=true"
import script from "./catSocialNetwork.vue?vue&type=script&lang=js"
export * from "./catSocialNetwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd5a2d2",
  null
  
)

export default component.exports